import React from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import sr from '../../scroll-reveal';

class Contact extends React.Component {
    componentDidMount() {
        sr.reveal('.contact-icon', {
            duration: 600,
            scale: 0.3,
            distance: '0px'
        }, 300);
    }

    render() {
        return (
            <section id="contact">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 mx-auto text-center">
                            <h2 className="section-heading">Let's Get In Touch</h2>
                            <hr className="my-4"/>
                            <p className="mb-5">
                                Ready to start your next project with us? <b>Great!</b><br/>
                                Shoot us an email and we will get back to you right away!
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12 ml-auto text-center">
                            <a href="mailto:info@novotec.io">
                                <span className="contact-icon">
                                    <FontAwesomeIcon className="fa-4x text-primary mb-3"
                                                     icon={["fas", "envelope"]}/>
                                </span>
                                <p>
                                    info@novotec.io
                                </p>
                            </a>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default Contact;


// WEBPACK FOOTER //
// ./src/js/App/Contact/Contact.js